import React from 'react'
import classNames from 'classnames'
import './StepProgressCounter.scss'

const CountBox = ({
  complete,
  isSponsoredStep,
  completeColor,
  incompleteColor,
}) => {
  return (
    <div
      style={{
        backgroundColor: complete
          ? completeColor
          : isSponsoredStep
          ? '#fff'
          : incompleteColor,
        borderRadius: '1.5px',
        width: '20px',
        height: '3px',
      }}
    />
  )
}

export const StepProgressCounter = ({
  total,
  currentStep,
  isSponsoredStep,
  label = 'Step',
  completeColor = '#4C3371',
  incompleteColor = '#C3C3C3',
}) => {
  return (
    <div className="step__counter">
      <span
        className={classNames(
          'step__counter__label',
          isSponsoredStep && 'sponsored',
        )}
      >
        {currentStep + 1} of {total}
      </span>
      
    </div>
  )
}
